import { Component, OnInit, ViewEncapsulation, OnDestroy, HostBinding } from '@angular/core';
import { Subscription, filter } from 'rxjs';
import { Router, RouterEvent, RouteConfigLoadStart, RouteConfigLoadEnd, Event } from '@angular/router';
import { GlobalConstants } from './meeting-manager/lib/global-constants';
import { Constants } from './meeting-manager/lib/constants';


/**
 * Application entry point
 */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})

export class AppComponent implements OnInit, OnDestroy {
    @HostBinding('class.app-root') css = true;

    showLoader = false;

    /**
     * Event subscriptions for omnibar events.
     */
    private subscriptions: Subscription = new Subscription();
    private notifyCount = 10;
    /**
     * Create an instance of {@link AppComponent}
     */
    constructor(
        private router: Router,
        public globalConstants: GlobalConstants,
        public constants: Constants,
    ) {
        let asyncLoadCount = 0;
        this.showLoader = false;
        router.events.pipe(filter((e: Event | RouterEvent): e is RouterEvent => e instanceof RouterEvent))
            .subscribe((event: RouterEvent) => {
                if (event instanceof RouteConfigLoadStart) {
                    asyncLoadCount++;
                } else if (event instanceof RouteConfigLoadEnd) {
                    asyncLoadCount--;
                }
                this.showLoader = !!asyncLoadCount;
            }
        );
        // this.router.navigate([''])
    }

    /**
     * Angular ngOnInit function
     */
    public ngOnInit() {
    }

    /**
     * Angular ngOnDestroy function
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
